import { NgModule } from "@angular/core";
import { PageContentComponent } from "@app/components/pageContent/pageContent.directive";
import { WebFooterComponent } from "@app/components/webFooter/webFooter.directive";
import { CommonModule } from "@angular/common";
import { DirectivesModule } from "@app/components/directives.module";
import { RouterLinkWithHref } from "@angular/router";

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        RouterLinkWithHref,
    ],
    exports: [
        PageContentComponent,
        WebFooterComponent,
    ],
    declarations: [
        PageContentComponent,
        WebFooterComponent,
    ]
})

export class SharedComponentModule {}
